import { useTranslation } from 'react-i18next';

import { BaseIngredientTabProps } from 'components/desktop/BaseIngredient/BaseIngredientComponent';
import 'components/desktop/BaseIngredient/BaseIngredientComponent.scss';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import NutriScoreSelect from 'components/desktop/_general/NutriScoreSelect/NutriScoreSelect';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';

export const BaseIngredientNutriScoreCard = ({
	state,
	handlers,
}: BaseIngredientTabProps): JSX.Element => {
	const { t } = useTranslation();

	const isBaseIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEBASEINGREDIENT,
	]);

	return (
		<FoldableCard
			disabled={!isBaseIngredientEditor}
			dataComponentType="baseingredient-nutriscore-card"
			defaultOpen={true}
			hasLock={true}
			defaultLocked={
				!(state.nutriScoreCategoryIsSetByUser === null
					? true
					: state.nutriScoreCategoryIsSetByUser)
			}
			handleLockClick={handlers.setNutriScoreCategoryIsSetByUser}
			title={t('_general:NUTRI_SCORE')}
			content={
				<NutriScoreSelect
					hasNutriScore={state.hasNutriScore ?? false}
					nutriScoreCategory={state.nutriScoreCategory}
					setHasNutriScore={handlers.setHasNutriScore}
					setNutriScoreCategory={handlers.setNutriScoreCategory}
					canImplyNutriScoreMethod={true}
					disabled={!isBaseIngredientEditor}
				></NutriScoreSelect>
			}
		/>
	);
};
